<template>
  <div class="d-flex justify-content-center align-items-center mt-5">
    <LoadingSpinner v-if="loading" text="...Anmeldedaten werden geprüft..." />

    <div v-else class="d-flex-col">
      <div class="mb-5 text-center">
        <!-- <font-awesome-icon icon="users-line" class="me-3 mb-2 fa-3x" /> -->
        <img src="@/assets/icons/zelos.png" alt="Zelos Logo" width="64" />
        <h1>Zelos</h1>
      </div>

      <section>
        <form class="form-signin p-0" @submit.prevent="login">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="floatingInput" placeholder="Anmeldename" autocomplete="username" v-model="user" required />
            <label for="floatingInput">Benutzername</label>
          </div>

          <div class="form-floating mb-3">
            <input
              type="password"
              class="form-control"
              id="floatingPassword"
              placeholder="Password"
              autocomplete="current-password"
              v-model="passwd"
              required
            />
            <label for="floatingPassword">Passwort</label>
          </div>

          <button type="submit" class="w-100 btn btn-lg btn-primary text-light">
            <font-awesome-icon icon="arrow-right-to-bracket" class="me-3" />
            Anmelden
          </button>
        </form>
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region imports
  import { computed, ref } from 'vue';
  import { useStore } from '@/store';

  import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';

  import { LoginRequest } from '@/models/AuthModels';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.authLoading);
  // const errorMsg = computed(() => store.getters.status.authErrorMsg);

  const user = ref('');
  const passwd = ref('');

  async function login() {
    var loginRequest = new LoginRequest(user.value, passwd.value);
    await store.dispatch(AuthActionTypes.Login, loginRequest);
  }
</script>
